import { alpha, styled } from '@mui/material';
import { DataGridPro, gridClasses, GridColDef } from '@mui/x-data-grid-pro';
import { CustomToolbar } from 'ui-component/grids/GridWithLevels/components';

export type ListProps = {
    loading: boolean;
    columns?: GridColDef[];
    rows?: readonly Record<string, any>[];
};

export const List = ({ loading, rows = [], columns = [] }: ListProps) => (
    <StripedDataGrid
        loading={loading}
        initialState={{ pinnedColumns: { right: ['actions'] } }}
        columns={columns}
        rows={rows}
        editMode="row"
        components={{
            Toolbar: CustomToolbar
        }}
        getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
        disableRowSelectionOnClick
        pagination
        checkboxSelection
    />
);

const ODD_OPACITY = 0.2;

/**
 *  @deprecated use the StripedDataGrid in ui-component/grids instead
 */
export const StripedDataGrid = styled(DataGridPro)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: theme.palette.secondary.dark,
            color: '#FFF',
            '& svg[data-testid="CheckBoxIcon"], svg[data-testid="CheckBoxOutlineBlankIcon"], .MuiTypography-root': {
                color: '#FFF'
            },
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.secondary.dark,
            color: '#FFF',
            '& svg[data-testid="CheckBoxIcon"], svg[data-testid="CheckBoxOutlineBlankIcon"], .MuiTypography-root': {
                color: '#FFF'
            },
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.selectedOpacity)
                }
            }
        }
    }
}));
